import React from 'react';
import Image from 'next/image';
import { formatDollarAmount, truncate } from '../../functions/bigNumber-util';
import { convertTimeToMili, timeFromEpoch, dateTimeFromEpoch } from '../../functions/format';
import moment from "moment";
import GlobalIcon from "../Icons/GlobalIcon";

function PoolCard({ pool, onOpenDetail }) {
    const countDownDate =
        (convertTimeToMili(Number(pool?.endJoinTime)) || 1) + 5000;
    const now = moment().utc().valueOf();
    const distance = countDownDate - now;

    return (
        <div
            tabIndex={0}
            onClick={onOpenDetail}
            onKeyDown={(event) => event.code === 'Enter' && onOpenDetail()}
            className="w-full p-4 rounded-xl shadow-md cursor-pointer zBg-4 border zBorder-1"
        // style={{ border: '1px solid #434457' }}
        >
            <div className="flex items-center">
                <div className="relative w-14 h-14">
                    <Image src="/images/logos/logo-white.png" alt="Logo" layout="fill" objectFit="contain" />
                </div>
                <div className="ml-4">
                    <p className="text-[12px] relative top-[5px] zText-green-primary">{`${Number(pool?.lockDuration) !== 0 ? '' : 'Flexible settlement'} `}</p>
                    <p className="text-[28px] font-bold zText-1 truncate">{pool?.name}</p>
                </div>
                <div className="ml-auto text-right">
                    <div className="border-l border-b border-t zBorder-1 w-[90px] pr-4 py-1 rounded-l-lg relative right-[-16px]">
                        <p className="text-[14px] font-medium zText-green-primary">APR</p>
                        <p className="text-[20px] leading-[20px] font-bold zText-1">{pool?.APR}%</p>
                    </div>
                </div>
            </div>
            <div className="mt-4 space-y-2 px-[9px]">

                {distance && distance > 0 ?

                    <div className="flex justify-between place-items-center items-center my-5-custom zBg-5 zBorder-light my-0 mx-[-26px] px-[26px] pt-[10px] pb-[12px]"
                    >
                        <div className="flex place-items-center">
                            <div className="relative w-10 h-10">
                                <Image
                                    src="/images/icons/calendar.svg"
                                    alt="Start date"
                                    layout="fill"
                                    objectFit="contain"
                                    width={40}
                                    height={40}
                                />
                            </div>
                            <div className="ml-3 flex item- place-items-center flex-col items-start	truncate">
                                <span className="text-xs zText-green-primary">Start date</span>
                                <p className="zText-1 text-sm">{timeFromEpoch(pool?.startJoinTime)}</p>
                            </div>
                        </div>

                        <div className="flex  place-items-center">
                            <div className="ml-3 text-right flex place-items-center flex-col items-end truncate">
                                <span className="text-xs zText-green-primary">End date</span>
                                <p className="zText-1 text-sm">{timeFromEpoch(pool?.endJoinTime)}</p>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="flex justify-between place-items-center items-center my-5-custom zBg-5 zBorder-light my-0 mx-[-26px] px-[26px] pt-[10px] pb-[12px]">
                        <div className="flex items-center">
                            <div className='w-10 h-10 flex place-items-center justify-center'>
                                <Image src="/images/icons/close.svg" alt="Closed Staked" width={24} height={24} />
                            </div>
                            <span className="ml-3 text-xs zText-green-primary">Closed</span>
                        </div>
                        <span className="text-md font-bold zText-1">Withdraw only</span>
                    </div>
                }

                <div className="flex justify-between items-center my-5-custom">
                    <div className="flex items-center">

                        <GlobalIcon />

                        <span className="ml-3 text-sm font-normal zText-green-primary">Global Staked</span>
                    </div>
                    <div className="flex flex-col items-end truncate">
                        <span className="text-lg font-bold zText-1">
                            {formatDollarAmount(pool?.totalStaked, 0)}
                            <span className='font-extralight'>{` SECOND`}</span>
                        </span>
                        <span className="text-base ">
                            ~{formatDollarAmount(pool?.totalStaked * pool?.SECONDPrice, 2, true)}
                            <span className='font-extralight'>{` USD`}</span>
                        </span>
                    </div>
                </div>

                {/* <div className="flex justify-between items-center my-5-custom">
                    <div className="flex items-center">
                        <Image src="/images/icons/calendar_1.svg" alt="Join time" width={40} height={40} />
                        <span className="ml-3 text-lg zText-green-primary">Join Time</span>
                    </div>
                    <span className="text-sm zText-1"> {pool?.joinTime && Number(pool?.joinTime) !== 0 ? timeFromEpoch(pool?.joinTime) : "--"}</span>
                </div> */}
                {distance && distance > 0 ?
                    <>
                        {pool?.balance > 0 ?
                            <div className="h-16 flex justify-between items-center p-1 rounded-2xl my-5-custom m-t-10 px-5 zBg-gradient-green-primary" >
                                <div className="flex items-center my-2 w-full">
                                    <Image src="/images/icons/user.svg" alt="Total Staked" width={40} height={40} />
                                    <div className="flex flex-col w-full ml-3">
                                        <span className=" text-[10px] font-bold text-white">TOTAL STAKED</span>
                                        <div className='flex place-items-center'>
                                            <span className="text-lg font-bold text-white pr-3">{formatDollarAmount(pool?.balance, 0)} SECOND</span>
                                            <span className="text-sm text-white">~{formatDollarAmount(pool?.balance * pool?.SECONDPrice, 0, true)} USD</span>
                                        </div>
                                    </div>

                                </div>
                                {/* <div className="flex flex-col items-end">
                                    <span className="text-lg font-bold zText-1">{formatDollarAmount(pool?.balance, 0)} SECOND</span>
                                    <span className="text-sm zText-1">~{formatDollarAmount(pool?.balance * pool?.SECONDPrice, 2, true)} USD</span>
                                </div> */}
                            </div>
                            :

                            <div className="h-16 flex justify-center items-center p-1 rounded-2xl my-5-custom m-t-10 px-5 zBg-gradient-green-primary">
                                <div className="flex items-center my-2">
                                    <Image src="/images/icons/user.svg" alt="STAKE NOW" width={30} height={30} />
                                    <span className="ml-3 text-lg font-bold text-white">STAKE NOW</span>
                                </div>
                            </div>
                        }
                    </>
                    :

                    <div className="h-16 flex justify-between items-center p-1 rounded-2xl my-5-custom m-t-10 px-5 zBg-gradient-3">
                        <div className="flex items-center my-2">
                            <Image src="/images/icons/user.svg" alt="You haven’t joined this stake." width={30} height={30} />
                            <span className="ml-3 text-md font-bold text-white">You haven’t joined this stake.</span>
                        </div>

                    </div>
                }
            </div>
        </div>
    );
}

export default PoolCard;
